import { createContext } from 'react';
const defaultLanguageContextProps = {
  language: '',
  languageOnChangeCallback: undefined
};
const LanguageContext = createContext(defaultLanguageContextProps);
export const LanguageContextProvider = LanguageContext.Provider;
export const LanguageContextConsumer = LanguageContext.Consumer;
export default LanguageContext;